import { Theme } from "@mui/material/styles";
import { alpha, SystemStyleObject } from "@mui/system";

const itemModelStyles = {
  assetWrapper: (
    theme: Theme,
    {
      isModelLoaded,
      isModelAvailable,
    }: { isModelLoaded: boolean; isModelAvailable: boolean },
  ): SystemStyleObject<Theme> => ({
    gridColumn: 1,
    gridRow: 1,
    display: "flex",
    justifyContent: "center",
    position: "relative",
    transition: theme.transitions.create("opacity", { duration: 1000 }),
    mx: isModelLoaded ? "unset" : "auto",
    width: "100%",

    "&::after": {
      content: "''",
      position: "absolute",
      pointerEvents: "none",
      top: "50%",
      left: 0,
      bottom: 0,
      right: 0,
      backgroundImage:
        !isModelLoaded && isModelAvailable
          ? `linear-gradient(0deg, ${alpha(
              theme.palette.background.default,
              1,
            )}, ${alpha("#000", 0)})`
          : "",
    },
  }),
  loader: (): SystemStyleObject<Theme> => ({
    position: "absolute",
    zIndex: 1,
    bottom: "2%",
    right: { xs: "5%", lg: "8%" },
    fontSize: 6,
  }),
};

export default itemModelStyles;
